import { render, staticRenderFns } from "./OtherplacesEditor.vue?vue&type=template&id=373f5c56&"
import script from "./OtherplacesEditor.vue?vue&type=script&lang=js&"
export * from "./OtherplacesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports